module.exports = __webpack_public_path__ + "img/get-ready-coffee.0edf92fd.png";